import axios from '../../axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TError, TStartGcsUpload, TStartGcsUploadResult } from '@onesource/schemas';
import { ENTITY } from '../entity';

interface StartGcsUploadInput {
  blockId: string;
  data: TStartGcsUpload;
}

export const useStartGcsUpload = () => {
  const queryClient = useQueryClient();
  return useMutation<TStartGcsUploadResult, TError, StartGcsUploadInput>({
    mutationFn: async ({ blockId, data }) => {
      const res = await axios.post<TStartGcsUploadResult>(`/community-hub/gcs-uploads/block/${blockId}/start`, data);
      return res.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'gcs-uploads', 'block', variables.blockId] });
    },
  });
};
